import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { FullScreenLoader } from "../Components/Loader";
import {
  getTCConnection,
  getTCProjects,
  setTCProject,
} from "../repositories/TCRepository";
import { logOut } from "../utils/AxiosHandlers";
import { Button as MuiButton } from "@mui/material";

export default function TrimbleProjects() {
  const [projects, setProjects] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isProjectsLoading, setIsProjectsLoading] = useState(false);

  const navigate = useNavigate();

  const fetchTCConnection = useCallback(() => {
    const infrakitToken = localStorage.getItem("infrakitToken");
    const infrakitAccessToken = JSON.parse(infrakitToken || "{}").accessToken;

    const connectionUuid = localStorage.getItem("connectionUuid");

    if (!infrakitAccessToken || !connectionUuid) {
      navigate("/");
    }

    setIsLoading(true);
    getTCConnection(connectionUuid!)
      .then((data) => {
        if (data.loggedInTC && data.projectSelected) {
          navigate("/folders");
        }
      })
      .finally(() => setIsLoading(false));
  }, [navigate]);

  useEffect(fetchTCConnection, [fetchTCConnection]);

  useEffect(() => {
    const connectionUuid = localStorage.getItem("connectionUuid");
    !connectionUuid && navigate("/");

    setIsProjectsLoading(true);
    getTCProjects(connectionUuid!)
      .then(setProjects)
      .finally(() => setIsProjectsLoading(false));
  }, [navigate]);

  const onSelectProject = (projectId: string) => {
    setIsLoading(true);
    const connectionUuid = localStorage.getItem("connectionUuid");
    setTCProject(connectionUuid!, projectId)
      .then((res) => !!res.data && navigate("/folders"))
      .finally(() => setIsLoading(false));
  };

  return (
    <div>
      <div className="header-button-container">
        <MuiButton
          variant="contained"
          className="header-button"
          onClick={logOut}
        >
          Logout
        </MuiButton>
        <MuiButton
          variant="contained"
          className="header-button"
          onClick={() => {
            localStorage.removeItem("connectionUuid");
            localStorage.removeItem("infrakitProjectUuid");
            navigate("/infrakit/projects");
          }}
        >
          Change Infrakit Project
        </MuiButton>
        <MuiButton
          variant="contained"
          className="header-button"
          onClick={() => {
            localStorage.removeItem("connectionUuid");
            navigate("/connections");
          }}
        >
          Change connection
        </MuiButton>
      </div>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <img
            src="https://connect.trimble.com/themes/trimble_connect/connect-logo.svg"
            alt="logo"
          />
          <div className="list">
            {projects.map((e) => (
              <div
                key={e.id}
                className="list-item"
                onClick={() => onSelectProject(e.id)}
              >
                <div className="flex column gap-2">
                  <p className="title">{e.name}</p>
                </div>
              </div>
            ))}
          </div>
          <p style={{ marginTop: "20px", textAlign: "center" }}>
            Note: Currently, only projects from Europe are listed.
          </p>
        </Box>
        {(isLoading || isProjectsLoading) && <FullScreenLoader isLoading />}
      </Container>
    </div>
  );
}
